/*
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-05-08 23:02:46
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-07-05 20:59:34
 * @FilePath: \vue-privilege-routing\src\store\modules\permission.js
 */
import { fetchPermission } from "../../api/index"
import router,{ DynamicRoutes } from "../../router/index"
import dynamicRouter from "../../router/dynamic-router"
import { recursionRouter,setDefaultRoute } from "../../utils/recursion-router"
import Home from "../../pages/home"
import axios from 'axios'

export default {
    namespaced:true,
    state:{
        permissionList:null,
        sidebarMenu:[],// 导航菜单
        currentMenu:'' // 高亮
    },
    getters:{},
    mutations:{
        SET_PERMISSION(state,routes){
            state.permissionList = routes;
        },
        CLEAR_PERMISSION(state){
            console.log('11111',state)
            state.permissionList = null;
        },
        SET_MENU(state,menu){
            state.sidebarMenu = menu;
        },
        CLEAR_MENU(state){
            state.sidebarMenu = []
        }
    },
    // 异步访问
    actions:{
        async FETCH_PERMISSION({ commit,state }){
            
            // 调接口,获取机构数据
            let permissionList = await fetchPermission();
            
            // 筛选 对比角色的route和所有route找到对应关系
            let routes = recursionRouter(permissionList,dynamicRouter);
           
            let MainContainer = DynamicRoutes.find(v => v.path === "");
            console.log("MainContainer",MainContainer)
            
            let children = MainContainer.children
            console.log("children",children,"routes",routes)
            children.push(...routes)

            console.log("children1",children)
            // 生成菜单
            commit("SET_MENU",children);

            // 设置默认路由
            setDefaultRoute([MainContainer]);
            // 初始化路由
            let initialRoutes = router.options.routes;
            
            router.addRoutes(DynamicRoutes);
            commit("SET_PERMISSION",[ ...initialRoutes , ...DynamicRoutes])
        }
        
    }
    

}